import KoioteBombCanvasQuesos from "./KoioteBombCanvasQuesos.vue";
import KoioteBombCanvasQuesosProperties from "./KoioteBombCanvasQuesosProperties.vue";
import KoioteBombCanvasQuesosPropery from "./default.json";

export default {
    install(Vue) {
        Vue.component(KoioteBombCanvasQuesos.name, KoioteBombCanvasQuesos);
        Vue.component(KoioteBombCanvasQuesosProperties.name, KoioteBombCanvasQuesosProperties);
        Vue.prototype.$KoioteBombCanvasQuesosPropery = KoioteBombCanvasQuesosPropery;
    },
};
